import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { isEmpty } from 'lodash';

import CargomaticInput from 'components/v2/input';
import CargomaticSelect from 'components/v2/select';
import Alert from 'components/ui/Alert';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

const DATE_FORMAT = 'L';

function getMomentDate(date) {
  if (!date) {
    return null;
  }

  return moment(date);
}

class LogPaymentModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState(props);
  }

  getInitialState(props) {
    return {
      error: null,
      amount: props.amount,
      paymentMethod: '',
      transactionId: '',
      transactionDate: '',
    };
  }

  clearState() {
    return {
      error: null,
      amount: '',
      paymentMethod: '',
      transactionId: '',
      transactionDate: '',
    };
  }

  onChange(key) {
    return (value) => {
      this.setState({ [key]: value });
    };
  }

  onDateSelect = (transactionDate) => {
    this.setState({ transactionDate });
  };

  onPaymentSelect = (selected) => {
    const { value: paymentMethod } = selected;
    this.setState({ paymentMethod });
  };

  renderError() {
    if (!this.state.error) {
      return null;
    }
    return <Alert dataTestId="Alert-588839ea" type="error">{this.state.error}</Alert>;
  }

  handleSave = () => {
    const { t } = this.props;

    const trimmedTransactionId = this.state.transactionId.trim();
    if (isEmpty(trimmedTransactionId)) {
      return this.setState({
        error: t('TRANSACTION_ID_ERROR'),
      });
    }

    if (!this.state.transactionDate) {
      return this.setState({
        error: t('TRANSACTION_DATE_ERROR'),
      });
    }
    const { amount, transactionId, transactionDate, paymentMethod } =
      this.state;

    this.props.onSave({
      amount,
      transactionId,
      transactionDate,
      paymentMethod,
    });

    this.setState(this.clearState());
    this.props.onHide();
  };

  render() {
    const { t } = this.props;
    const paymentMethods = [
      {
        name: t('CHECK'),
        value: 'check',
      },
      {
        name: t('MANUAL'),
        value: 'manual',
      },
    ];
    return (
      (<Modal show={this.props.show} onHide={this.props.onHide} enforceFocus={false}>
        <Modal.Header data-testid="undefined-b6c3fab6">
          <strong data-testid="strong-55968fa3">{t('LOG_A_PAYMENT')}</strong>
        </Modal.Header>
        <Modal.Body data-testid="undefined-a6d26f09">
          {this.renderError()}
          <div data-testid="div-49550896" className="grid grid-cols-2 gap-4">
            <CargomaticInput
              dataTestId="CargomaticInput-9438dec6"
              name="amount"
              value={this.state.amount}
              onChange={this.onChange('amount')}
              type="text"
              label={t('AMOUNT')}
              className="mb-4"
              placeholder={t('AMOUNT')}
              disabled />
            <CargomaticSelect
              dataTestId="CargomaticSelect-b294f2b6"
              label={t('PAYMENT_METHOD')}
              items={paymentMethods}
              onSelect={this.onPaymentSelect}
              value={this.state.paymentMethod}
              className="mb-4"
              textKey="name"
              valueKey="value"
              placeholder={t('PAYMENT_METHOD')}
              showCaption />
            <CargomaticInput
              dataTestId="CargomaticInput-30e16eea"
              name="transactionId"
              value={this.state.transactionId}
              onChange={this.onChange('transactionId')}
              type="text"
              label={t('TRANSACTION_ID_LABEL')}
              className="mb-4"
              placeholder={t('TRANSACTION_ID')} />
            <div data-testid="div-3f2ed167" className="mb-4">
              <label
                data-testid="label-4ad25449"
                htmlFor="startDate"
                className="block mb-1 form-label">
                {t('TRANSACTION_DATE')}
              </label>
              <DatePicker
                id="transactionDate"
                name="transactionDate"
                selected={getMomentDate(this.state.transactionDate)}
                onChange={this.onDateSelect}
                className="form-field"
                dateFormat={DATE_FORMAT}
                shouldCloseOnSelect
                placeholderText={t('TRANSACTION_DATE')}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer data-testid="undefined-874bba23">
          <button
            data-testid="button-99e58e3a"
            className="button button-green"
            type="button"
            onClick={this.handleSave}>
            {titleize(t('SAVE'))}
          </button>
          <button
            data-testid="button-4599e9ff"
            className="button button-secondary"
            type="button"
            onClick={this.props.onHide}>
            {titleize(t('CLOSE'))}
          </button>
        </Modal.Footer>
      </Modal>)
    );
  }
}

export default withTranslation()(LogPaymentModal);
